import { render } from "./Desktop.vue?vue&type=template&id=65e3a192&scoped=true&bindings={\"upvotes\":\"data\",\"downvotes\":\"data\",\"hasVoted\":\"data\",\"resetModalActive\":\"data\",\"pollId\":\"data\",\"round\":\"data\",\"totalUpvotes\":\"options\",\"totalDownvotes\":\"options\",\"pollLink\":\"options\",\"upvote\":\"options\",\"downvote\":\"options\",\"sendUpdate\":\"options\"}"
import script from "./Desktop.vue?vue&type=script&lang=js"
export * from "./Desktop.vue?vue&type=script&lang=js"

import "./Desktop.vue?vue&type=style&index=0&id=65e3a192&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-65e3a192"

export default script